import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegVisualizacaoService } from '../../../../services/smartinteg-visualizacao.service';
import { RegistroVisualizacaoResponse, StatusIntegracaoRegistro } from '../../../../types/smartinteg';
import { ToastService } from '../../../../services/toast.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-registro-visualizacao-list',
  templateUrl: './registro-visualizacao-list.component.html'
})
export class RegistroVisualizacaoListComponent implements OnInit {
  processoId!: string;
  registros: RegistroVisualizacaoResponse[] = [];
  colunas: string[] = [];
  loading: boolean = true;
  totalRecords: number = 0;
  
  // Filtros
  statusSelecionado: StatusIntegracaoRegistro | null = null;
  mapeamentoId: number | null = null;
  dataInicio: Date | null = null;
  dataFim: Date | null = null;
  busca: string = '';
  
  opcoesStatus = [
    { label: 'Todos', value: null },
    { label: 'Pendente', value: StatusIntegracaoRegistro.PENDENTE },
    { label: 'Integrado', value: StatusIntegracaoRegistro.INTEGRADO },
    { label: 'Erro', value: StatusIntegracaoRegistro.ERRO }
  ];

  itemsExportar: MenuItem[] = [
    {label: 'CSV', icon: 'pi pi-file', command: () => this.exportar('csv')},
    {label: 'Excel', icon: 'pi pi-file-excel', command: () => this.exportar('xlsx')},
    {label: 'JSON', icon: 'pi pi-code', command: () => this.exportar('json')}
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private visualizacaoService: SmartintegVisualizacaoService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.processoId = this.route.snapshot.paramMap.get('id')!;
    this.carregarRegistros();
  }

  carregarRegistros(event?: any): void {
    this.loading = true;
    
    const page = event ? event.first / event.rows : 0;
    const size = event ? event.rows : 20;
    
    this.visualizacaoService.listarRegistrosVisualizacao(
      this.processoId,
      this.statusSelecionado,
      this.mapeamentoId,
      this.dataInicio,
      this.dataFim,
      this.busca,
      page,
      size
    ).subscribe({
      next: (res) => {
        // Suporte para variação na resposta da paginação (conteudo vs content)
        this.registros = res.conteudo || (res as any).registros || [];
        this.totalRecords = res.totalElementos || (res as any).totalElements || 0;
        
        // Extrair colunas dinâmicas dos dados se houver registros
        if (this.registros.length > 0 && this.registros[0].dados) {
          // Pega as chaves do primeiro registro, limitando a 5 para não quebrar o layout da tabela se houver muitas
          this.colunas = Object.keys(this.registros[0].dados).slice(0, 8);
        }

        // Log para debug
        console.log('Registros Visualização:', this.registros);
        
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao buscar registros:', err);
        this.loading = false;
      }
    });
  }

  aplicarFiltros(): void {
    this.carregarRegistros();
  }

  limparFiltros(): void {
    this.statusSelecionado = null;
    this.mapeamentoId = null;
    this.dataInicio = null;
    this.dataFim = null;
    this.busca = '';
    this.carregarRegistros();
  }

  verDetalhes(id: number): void {
    this.router.navigate(['/smartinteg/monitor/registros', id], { queryParams: { tipo: 'visualizacao' } });
  }

  exportar(formato: 'csv' | 'xlsx' | 'json'): void {
    this.visualizacaoService.exportarDados(
      this.processoId, 
      'visualizacao', 
      formato, 
      this.statusSelecionado, 
      this.dataInicio, 
      this.dataFim
    ).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `visualizacao_${this.processoId}_${new Date().getTime()}.${formato}`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao exportar dados.');
      }
    });
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/monitor/processos']);
  }
}
